import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }

import { reactive, ref, unref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElButton, ElTag, ElMessage } from 'element-plus';
import { useLocales } from '@/hooks/useLocales';
import moment from 'moment';

/* Plugins */
import { DicGroupDialog, DicListDialog } from './components/Index';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';

/* Apis */
import { GetDicGroupListApi, DeleteDicGroupApi } from '../../../apis/dic_groups/api';

/* Types */
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { DicGroupListDto, DicGroupListSearch } from '../../../apis/dic_groups/dto';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogRef = ref<ComponentRef<typeof DicGroupDialog>>();
const listDialogRef = ref<ComponentRef<typeof DicListDialog>>();

// 获取多语言翻译函数
const { t } = useLocales();

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<DicGroupListDto>({
	getListApi: GetDicGroupListApi,
	delListApi: DeleteDicGroupApi,
	response: { data: 'data', total: 'total' },
});

const state = reactive({
	loading: false,
	search: {} as any,
	paged: { current: 1, page_size: 20 },
});

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'code', label: t('dictionary.table.groupCode', '组编号'), columnWidth: '150' },
	{ field: 'group_name', label: t('dictionary.table.groupName', '组名称'), columnWidth: '150' },
	{ field: 'remark', label: t('dictionary.table.remark', '备注'), align: 'left' },
	{ field: 'sort', label: t('dictionary.table.sort', '排序'), columnWidth: '80', align: 'center' },
	{ field: 'is_enabled', label: t('dictionary.table.status', '状态'), columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: t('dictionary.table.createdTime', '创建时间'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '150px', label: t('dictionary.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const actions = {
	search: () => {
		const searchInput = Object.assign({}, state.search, state.paged);
		methods.setSearchParams(searchInput);
	},
	reSetSearch: () => {
		state.search = {};
		methods.resetParams(state.search);
	},
	/* 创建 */
	create: () => {
		unref(dialogRef)?.showDialog('', false);
	},

	/* 编辑 */
	editActions: (rowId: string) => {
		unref(dialogRef)?.showDialog(rowId, true);
	},

	/* 删除 */
	delete: async (row: any) => {
		await methods.deleteRows({ id: row?.id, revision: row?.revision });
	},

	/* 字典列表 */
	showListDialog: (rowId: string) => {
		unref(listDialogRef)?.showDialog(rowId);
	},
};

onMounted(async () => {
	tableObject.pageSize = 20;
	actions.search();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).search,
          inline: true,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('dictionary.form.groupCode', '组编号')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).search.code) = $event)),
                  placeholder: _unref(t)('dictionary.placeholder.enterGroupCode', '请输入组编号')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              "label-width": '80px',
              label: _unref(t)('dictionary.form.groupName', '组名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).search.group_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).search.group_name) = $event)),
                  placeholder: _unref(t)('dictionary.placeholder.enterGroupName', '请输入组名称')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ElButton), {
                      icon: "Refresh",
                      onClick: actions.reSetSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.reset', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      icon: "Search",
                      onClick: actions.search
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(ElButton), {
            size: "small",
            type: "primary",
            onClick: actions.create
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('dictionary.buttons.createDicGroup', '创建字典组')), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          created_time: _withCtx(({ row }) => [
            _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          is_enabled: _withCtx(({ row }) => [
            (row.is_enabled == 'Y')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 0,
                  size: "small",
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.enabled', '启用')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.is_enabled == 'N')
              ? (_openBlock(), _createBlock(_unref(ElTag), {
                  key: 1,
                  size: "small",
                  type: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('status.diabled', '停用')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(ElButton), {
                type: "primary",
                link: "",
                onClick: ($event: any) => (actions.editActions(row.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dictionary.buttons.edit', '编辑')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_unref(ElButton), {
                type: "success",
                link: "",
                onClick: ($event: any) => (actions.showListDialog(row.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dictionary.buttons.dictionary', '字典')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_dropdown, {
                style: {"padding":"2px","margin-left":"12px"},
                trigger: "click"
              }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "primary",
                            link: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(row.is_enabled == 'Y' ? _unref(t)('dictionary.buttons.disable', '停用') : _unref(t)('dictionary.buttons.enable', '启用')), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_dropdown_item, { divided: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ElButton), {
                            size: "small",
                            type: "danger",
                            link: "",
                            onClick: ($event: any) => (actions.delete(row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('dictionary.buttons.delete', '删除')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_More)
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }),
    _createVNode(_unref(DicGroupDialog), {
      ref_key: "dialogRef",
      ref: dialogRef,
      onRefresh: actions.search
    }, null, 8, ["onRefresh"]),
    _createVNode(_unref(DicListDialog), {
      ref_key: "listDialogRef",
      ref: listDialogRef
    }, null, 512)
  ], 64))
}
}

})